<!--
 * @Description:市场营销-线索管理联系人，投放记录联系人  props edisabled 不可以编辑
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-10-25 17:48:03
 * @LastEditors: cxh
-->

<template>
  <cos-modal
    v-model:visible="visible"
    :title="form.id ? '编辑' : '新增'"
    class="clueMerge"
    width="870px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="form" ref="formRef" v-if="visible">
      <dc-layout-card :span="12">
        <dc-form-item
          name="name"
          :rules="[
            {
              required: true,
              message: '请输入'
            },
            {
              validator: concatNameValidate
            }
          ]"
          label="联系人名称"
        >
          <CosInput v-model:value="form.name" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="性别">
          <CosSelect v-model:value="form.sex" placeholder="请选择" :options="dataConfig.genderEnum" allow-clear />
        </dc-form-item>
        <dc-form-item label="角色">
          <CosSelect
            v-model:value="form.jobRole"
            placeholder="请选择"
            :options="dataConfig.linkRoleTypeEnum"
            allow-clear
          />
        </dc-form-item>
        <dc-form-item
          name="mobile"
          label="手机号"
          :rules="[
            {
              validator: (rule, value) => contactValidate(rule, value, form, formRef)
            }
          ]"
        >
          <CosInput v-model:value="form.mobile" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="email"
          label="邮箱"
          :rules="[
            {
              validator: (rule, value) => contactValidate(rule, value, form, formRef)
            }
          ]"
        >
          <CosInput v-model:value="form.email" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="wechat"
          label="微信号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.wechat" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="qq"
          label="QQ号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.qq" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="tel"
          label="固定电话"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.tel" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item label="备注" :span="24">
          <CosTextarea v-model:value="form.remark" :maxlength="2000" placeholder="请输入" />
        </dc-form-item>
      </dc-layout-card>
    </a-form>
  </cos-modal>
</template>
<script setup lang="ts">
import { ref, useAttrs } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { zbuContactEdit, zbuContactAdd } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import { contactValidate, concatNameValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
const attrs = useAttrs()
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<ClueManage['contact']>({})
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  contactRefId: {
    type: String
  }
})
const emit = defineEmits(['success'])
const success = (type: 'add' | 'edit') => {
  emit('success', type)
}
const toggle = (row: ClueManage['contact']) => {
  form.value = row ? cloneDeep(row) : {}
  visible.value = !visible.value
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    if (attrs.onSubmit && typeof attrs.onSubmit === 'function') {
      attrs.onSubmit(form.value, (res: any) => {
        loading.value = false
      })
      return
    }
    try {
      if (form.value?.id) {
        await zbuContactEdit(form.value)
        success('edit')
        message.success('编辑成功')
      } else {
        await zbuContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        success('add')
        message.success('新增成功')
      }
      visible.value = false
    } catch (error) {}
    loading.value = false
  })
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'ContactsModal' }
</script>
